module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("hN6nw"))).then(() => parcelRequire('1iHdE'));